import { selectedWalletReducer } from '../reducers/selectedWalletReducer';
import {selectedWalletMoreInfoReducer} from "../reducers/selectedWalletMoreInfoReducer";

export const selectedWalletInfo = (wallet_info) => async (dispatch) => {
    dispatch((selectedWalletReducer(JSON.stringify(wallet_info))));
  };

export const addWalletMoreInfo = (info) => async (dispatch) => {
    dispatch((selectedWalletMoreInfoReducer(info)));
};